// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresWinnerRemoveBody = {
  poolId: string;
  winnerId: string;
};

export type typeSquaresWinnerRemoveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { winnerId: string };
};

export type typeSquaresWinnerRemoveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresWinnerRemoveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresWinnerRemoveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresWinnerRemoveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    winnerId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "winnerId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresWinnerRemove(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresWinnerRemoveBody);
  }

  return async function postSquaresWinnerRemove(
    payload: typeSquaresWinnerRemoveBody,
  ): Promise<
    typeSquaresWinnerRemoveOutput200 | typeSquaresWinnerRemoveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresWinnerRemove" failed before calling the network. #e38b3282023f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e38b3282023f" },
        },
        data: null,
      } as typeSquaresWinnerRemoveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/winner-remove`,
      httpMethod: "POST",
      options,
    })) as typeSquaresWinnerRemoveOutput200 | typeSquaresWinnerRemoveOutput400;
  };
}
